/**
 * Transforms objects, removing a property from each
 */
export function omitFromArray<T, K extends keyof T>(objects: T[], key: K): Omit<T, K>[] {
    return objects.map((obj) => omit(obj, key));
}

/**
 * Transforms an object to another, removing a property
 */
export function omit<T, K extends keyof T>(object: T, key: K): Omit<T, K> {
    const dup = {
        ...object,
    };
    delete dup[key];
    return dup;
}
